import { DateTime } from 'luxon';
import { FeatureFlagService } from '../services/feature-flag.service';
import { IBetaFlagState } from '@/beta-flag/store/beta-flag.types';
import { EFeatureFlag } from '@/beta-flag/enums/feature-flag';
import { EnumUserRoles } from '@/enums/UserRole';

export class BetaFlagHelper {
  static isContentLibraryFlagSet(state: IBetaFlagState): boolean {
    return Number.isInteger(state.flags.contentLibrary);
  }

  static contentLibraryAllowed(state: IBetaFlagState): boolean {
    return state.flags.contentLibrary === 1;
  }

  static dismissContentLibraryOptIn(
    entityId: string,
    userId: string,
    userRole: EnumUserRoles
  ): void {
    const expirationDate: DateTime =
      userRole === EnumUserRoles.admin ? DateTime.now().plus({ hours: 72 }) : undefined;
    this.dismissFeatureOptIn(entityId, userId, EFeatureFlag.ContentLibrary, expirationDate);
  }

  static dismissFeatureOptIn(
    entityId: string,
    userId: string,
    feature: EFeatureFlag,
    expirationDate?: DateTime
  ): void {
    const expirationDateMs: number = expirationDate ? expirationDate.toMillis() : undefined;
    localStorage.setItem(
      this.getStorageKey(entityId, userId, feature),
      JSON.stringify({
        expirationDate: expirationDateMs,
      })
    );
  }

  static async showFeatureOptIn(
    entityId: string,
    userId: string,
    feature: EFeatureFlag,
    startDate?: DateTime
  ): Promise<boolean> {
    const now: DateTime = DateTime.now();
    if (startDate && startDate > now) {
      return false;
    }

    const isBlacklisted: boolean = await FeatureFlagService.isBlacklisted(feature);
    if (isBlacklisted) {
      return false;
    }

    const data: string = localStorage.getItem(this.getStorageKey(entityId, userId, feature));
    if (!data) {
      return true;
    }
    try {
      const { expirationDate } = JSON.parse(data);
      if (!expirationDate) {
        return false;
      }
      const date: DateTime = DateTime.fromMillis(expirationDate);
      if (date > now) {
        return false;
      }
      localStorage.removeItem(this.getStorageKey(entityId, userId, feature));
      return true;
    } catch {
      return true;
    }
  }

  static getStorageKey(entityId: string, userId: string, feature: EFeatureFlag): string {
    return `${feature}_${entityId}_${userId}`;
  }
}
